import React, { useContext, useEffect, useRef, useState } from 'react';
import MenuHeader from './../MenuHeader';
import DraggableItem from './DraggableItem';
import { ProductContext } from '../../../../store';

const HiddenProducts = () => {
	const divRef = useRef(null),
		[pageLoader, setPageLoader] = useState(true),
		[hoverProductId, setHoverProductId] = useState(null),
		[height, setHeight] = useState("100vh"),
		[actionLoader, setActionLoader] = useState(false),
		[buriedNotAttached, setBuriedNotAttached] = useState([]),
		{
			products,
			setProducts,
			productCount,
			shopCurrency,
			hasMore,
			productOrder,
			promoted,
			setPromoted,
			buried,
			setBuried,
			buriedProducts,
			setBuriedProducts,
			hiddenProducts,
			hidden,
			setHidden,
			setHiddenProducts,
			pinnedItems,
			setPinnedItems,
			setPinnedProductIndex,
			pinnedProductIndex,
			originalProducts,
			setOriginalProducts,
			hiddenProductIndex,
			setHiddenProductIndex,
			originalProductOrder,
			selectedPromoTiles,
			setSelectedPromoTiles,
			dynamicItems,
			setDynamicItems
		} = useContext(ProductContext)

	useEffect(() => {
		const calculateHeight = () => {
			if (divRef.current) {
				const topPosition = divRef.current.getBoundingClientRect().top
				const newHeight = `calc(100vh - ${topPosition}px)`
				setHeight(newHeight)
			}
		}
		// Calculate height initially
		calculateHeight()

		// Recalculate height on window resize
		window.addEventListener("resize", calculateHeight)
		return () => {
			window.removeEventListener("resize", calculateHeight)
		}
	}, [divRef])

	useEffect(() => {
		if (!hasMore && buriedNotAttached.length > 0) {
			let buriedNotAttachedLocal = [...buriedNotAttached],
				productsLocal = [...products]
			for (let i = 0; i < buriedNotAttachedLocal.length; i++) {
				let currentBuriedNotAttached = buriedNotAttachedLocal[i]
				productsLocal.push(currentBuriedNotAttached)
			}
			setProducts(productsLocal)
			setBuriedNotAttached([])
		}
	}, [hasMore, buriedNotAttached])

	const getPriceRange = (product) => {
		let min = product.price,
			max = product.price;
		if (typeof product.variants !== "undefined" && product.variants.length > 0) {
			min = product.variants[0].calculated_price > 0 ? product.variants[0].calculated_price : (product.variants[0].sale_price > 0 ? product.variants[0].sale_price : product.variants[0].price)
			max = min
			for (let i = 0; i < product.variants.length; i++) {
				let currentVariant = product.variants[i]
				if (currentVariant.calculated_price > 0) {
					if (min > currentVariant.calculated_price) {
						min = currentVariant.calculated_price
					} else if (max < currentVariant.calculated_price) {
						max = currentVariant.calculated_price
					}
				} else if (currentVariant.sale_price > 0) {
					if (min > currentVariant.sale_price) {
						min = currentVariant.sale_price
					} else if (max < currentVariant.sale_price) {
						max = currentVariant.sale_price
					}
				} else if (currentVariant.price > 0) {
					if (min > currentVariant.price) {
						min = currentVariant.price
					} else if (max < currentVariant.price) {
						max = currentVariant.price
					}
				}
			}
		}
		return { min, max }
	}

	const formPriceText = (price) => {
		let priceAmt = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: shopCurrency,
		}).format(price);
		return priceAmt
	}

	const formatPrice = (product) => {
		let { min, max } = getPriceRange(product)
		if (min === max) {
			if (product.sale_price > 0) {
				return <><span className="cbPriceList">{formPriceText(product.sale_price)}</span><span className="cbPriceList cbOriginalPrice">{formPriceText(product.price)}</span></>
			} else {
				return <span className="cbPriceList">{formPriceText(product.price)}</span>
			}
		} else {
			let minPrice = formPriceText(min),
				maxPrice = formPriceText(max);
			return <span className="cbPriceList">{minPrice} - {maxPrice}</span>
		}
	}

	const productMouseOver = (producId) => {
		if (hoverProductId !== producId) {
			setHoverProductId(producId)
		}
	}

	const promptProduct = (productId) => {
		setActionLoader(true)
		let promotedLocal = [...promoted],
			pinnedItemsLocal = { ...pinnedItems },
			buriedLocal = [...buried],
			dynamicItemsLocal = {...dynamicItems},
			buriedProductsLocal = [...buriedProducts],
			productIndex = productOrder.get(productId) ?? -1,
			productsLocal = [...products],
			selectedPromoTilesLocal	= {...selectedPromoTiles},
			pinnedWIthPromoted = {...pinnedItemsLocal, ...selectedPromoTilesLocal},
			element = productIndex >= 0 ? productsLocal.splice(productIndex, 1)[0] : {},
			promotedPinned	= {},
			buriedPinned	= {},
			onlyPinnedItemsLocal =  {},
			pinnedPositions = [],
			pPPPosition = typeof pinnedItemsLocal[productId] !== "undefined" ? pinnedItemsLocal[productId] : null,
			promotedPosition = 0;
		Object.keys(pinnedWIthPromoted).forEach((item) => {
			if( promotedLocal.indexOf(item) !== -1 ){
				promotedPinned[item] = pinnedWIthPromoted[item]
			}else if( buriedLocal.indexOf(item) !== -1 ){
				buriedPinned[item] = pinnedWIthPromoted[item]
			}else{
				onlyPinnedItemsLocal[item] = pinnedWIthPromoted[item]
			}
		})
		pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		if(productIndex === -1){
			return
		}
		while( pinnedPositions.indexOf(promotedPosition) !== -1 ){
			promotedPosition = promotedPosition + 1
		}
		if( typeof onlyPinnedItemsLocal[productId] !== "undefined" ){
			delete onlyPinnedItemsLocal[productId]
			delete pinnedItemsLocal[productId]
			pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		}
		if (buriedLocal.indexOf(productId) !== -1) {
			let buriedIndex = buriedLocal.indexOf(productId)
			buriedLocal.splice(buriedIndex, 1)
			buriedProductsLocal.splice(buriedIndex, 1)
			let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentBuriedPosition = sortedKeyArray.indexOf(productId)
			for( let i = 0; i < currentBuriedPosition; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition + 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			delete buriedPinned[productId]
		}
		if (promotedLocal.indexOf(productId) === -1) {
			for( let i = 0; i < promotedLocal.length; i++ ){
				if( typeof pinnedItemsLocal[promotedLocal[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[promotedLocal[i]] + 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition + 1
					}
					pinnedItemsLocal[promotedLocal[i]] = newChangePosition
				}
			}
			promotedLocal.push(productId)
		}else if( promotedLocal.indexOf(productId) !== -1 ){
			let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentPromotedPosition = sortedKeyArray.indexOf(productId)
			for( let i = 0; i < currentPromotedPosition; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition + 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
		}
		productsLocal.splice(promotedPosition, 0, element)
		pinnedItemsLocal[productId] = promotedPosition
		if (typeof pinnedProductIndex[productId] === "undefined") {
			let pinnedProductIndexLocal = { ...pinnedProductIndex }
			pinnedProductIndexLocal[productId] = originalProductOrder.get(productId)
			setPinnedProductIndex(pinnedProductIndexLocal)
		}
		let positionIdsNew	= {...pinnedItemsLocal, ...selectedPromoTilesLocal, ...dynamicItemsLocal},
			pinnedProductIds = Object.entries(positionIdsNew).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key);
		if (pinnedProductIds.length > 0) {
			const idIndexMapLocal = new Map();
			let elements = []
			productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let currentProductId = pinnedProductIds[i]
				let productIndex = idIndexMapLocal.get(currentProductId)
				let element = productsLocal.splice(productIndex, 1)[0]
				productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
				elements.push(element)
			}
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let element = elements[i]
				let currentProductId = pinnedProductIds[i]
				productsLocal.splice(positionIdsNew[currentProductId], 0, element)
			}
		}
		setBuriedProducts(buriedProductsLocal)
		setBuried(buriedLocal)
		setSelectedPromoTiles(selectedPromoTilesLocal)
		setPinnedItems(pinnedItemsLocal)
		setPromoted(promotedLocal)
		setProducts(productsLocal)
		setDynamicItems(dynamicItemsLocal)
		setActionLoader(false)
	}

	const buriedProduct = (productId) => {
		setActionLoader(true)
		let buriedLocal = [...buried],
			promotedLocal = [...promoted],
			pinnedItemsLocal = { ...pinnedItems },
			dynamicItemsLocal = {...dynamicItems},
			buriedProductsLocal = [...buriedProducts],
			productIndex = productOrder.get(productId) ?? -1,
			selectedPromoTilesLocal	= {...selectedPromoTiles},
			buriedNotAttachedLocal = [...buriedNotAttached],
			pinnedWIthPromoted = {...pinnedItemsLocal, ...selectedPromoTilesLocal},
			productsLocal = [...products],
			element = productIndex >= 0 ? productsLocal.splice(productIndex, 1)[0] : {},
			promotedPinned	= {},
			buriedPinned	= {},
			onlyPinnedItemsLocal =  {},
			pinnedPositions = [],
			pPPPosition = typeof pinnedItemsLocal[productId] !== "undefined" ? pinnedItemsLocal[productId] : null,
			buriedPosition = productsLocal.length;
		Object.keys(pinnedWIthPromoted).forEach((item) => {
			if( promotedLocal.indexOf(item) !== -1 ){
				promotedPinned[item] = pinnedWIthPromoted[item]
			}else if( buriedLocal.indexOf(item) !== -1 ){
				buriedPinned[item] = pinnedWIthPromoted[item]
			}else{
				onlyPinnedItemsLocal[item] = pinnedWIthPromoted[item]
			}
		})
		pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		if(productIndex === -1){
			return
		}
		while( pinnedPositions.indexOf(buriedPosition) !== -1 ){
			buriedPosition = buriedPosition - 1
		}
		if( typeof onlyPinnedItemsLocal[productId] !== "undefined" ){
			delete onlyPinnedItemsLocal[productId]
			delete pinnedItemsLocal[productId]
			pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		}
		if (promotedLocal.indexOf(productId) !== -1) {
			let promotedIndex = promotedLocal.indexOf(productId)
			promotedLocal.splice(promotedIndex, 1)
			let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentPromotedPosition = sortedKeyArray.indexOf(productId)
			for( let i = currentPromotedPosition+1; i < sortedKeyArray.length; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition - 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			delete promotedPinned[productId]
			// for( let i = productIndex; i < productsLocal.length; i++ ){
			// 	if( typeof productsLocal[i] !== "undefined" ){
			// 		let loopProductId = productsLocal[i].id
			// 		if( promotedLocal.indexOf(loopProductId) !== -1 ){
			// 			pinnedItemsLocal[loopProductId]	= pinnedItemsLocal[loopProductId] - 1
			// 		}else{
			// 			break;
			// 		}
			// 	}else{
			// 		break;
			// 	}
			// }
		}
		if (buriedLocal.indexOf(productId) === -1) {
			let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			for( let i = 0; i < sortedKeyArray.length; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition - 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			buriedLocal.push(productId)
			buriedProductsLocal.push(element)
			// for( let i = productsLocal.length-1; i >= 0; i-- ){
			// 	if( typeof productsLocal[i] !== "undefined" ){
			// 		let loopProductId = productsLocal[i].id
			// 		if( buriedLocal.indexOf(loopProductId) !== -1 ){
			// 			pinnedItemsLocal[loopProductId]	= pinnedItemsLocal[loopProductId] - 1
			// 		}else{
			// 			break;
			// 		}
			// 	}else{
			// 		break;
			// 	}
			// }
		} else if (buriedLocal.indexOf(productId) !== -1) {
			let buriedIndex = buriedLocal.indexOf(productId),
				buriedProductId = buriedLocal.splice(buriedIndex, 1)[0],
				burriedProduct = buriedProductsLocal.splice(buriedIndex, 1)[0]
			buriedLocal.splice(buriedLocal.length, 0, buriedProductId)
			buriedProductsLocal.splice(buriedProductsLocal.length, 0, burriedProduct)
			let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentBuriedPosition = sortedKeyArray.indexOf(productId)
			for( let i = currentBuriedPosition+1; i < sortedKeyArray.length; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition - 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			delete buriedPinned[productId]
			// for( let i = productIndex; i < productsLocal.length; i++ ){
			// 	if( typeof productsLocal[i] !== "undefined" ){
			// 		let loopProductId = productsLocal[i].id
			// 		if( buriedLocal.indexOf(loopProductId) !== -1 ){
			// 			pinnedItemsLocal[loopProductId]	= pinnedItemsLocal[loopProductId] - 1
			// 		}else{
			// 			break;
			// 		}
			// 	}else{
			// 		break;
			// 	}
			// }
		}
		if ( buriedPosition <= productsLocal.length ) {
			productsLocal.splice(buriedPosition, 0, element)
		} else {
			buriedNotAttachedLocal.push(element)
		}
		pinnedItemsLocal[productId] = buriedPosition
		if (typeof pinnedProductIndex[productId] === "undefined") {
			let pinnedProductIndexLocal = { ...pinnedProductIndex }
			pinnedProductIndexLocal[productId] = originalProductOrder.get(productId)
			setPinnedProductIndex(pinnedProductIndexLocal)
		}

		let positionIdsNew	= {...pinnedItemsLocal, ...selectedPromoTilesLocal, ...dynamicItemsLocal},
			pinnedProductIds = Object.entries(positionIdsNew).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key);
		if (pinnedProductIds.length > 0) {
			const idIndexMapLocal = new Map();
			let elements = []
			productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let currentProductId = pinnedProductIds[i]
				let productIndex = idIndexMapLocal.get(currentProductId)
				if( typeof productIndex !== "undefined" ){
					let element = productsLocal.splice(productIndex, 1)[0]
					productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
					elements.push(element)
				}
			}
			for( let i = 0; i < elements.length; i++ ){
				let element = elements[i]
				let currentProductId = element.id
				productsLocal.splice(positionIdsNew[currentProductId], 0, element)
			}
		}
		setPromoted(promotedLocal)
		setBuriedNotAttached(buriedNotAttachedLocal)
		setSelectedPromoTiles(selectedPromoTilesLocal)
		setPinnedItems(pinnedItemsLocal)
		setBuried(buriedLocal)
		setBuriedProducts(buriedProductsLocal)
		setProducts(productsLocal)
		setDynamicItems(dynamicItemsLocal)
		setActionLoader(false)
	}

	const restoreProduct = (productId) => {
		let pinnedItemsLocal	= {...pinnedItems},
			buriedLocal	= [...buried],
			buriedProductsLocal = [...buriedProducts],
			pinnedProductIndexLocal	= {...pinnedProductIndex},
			promotedLocal	= [...promoted],
			hiddenLocal	= [...hidden],
			hiddenProductsLocal	= [...hiddenProducts],
			selectedPromoTilesLocal	= {...selectedPromoTiles},
			hiddenProductIndexLocal	= {...hiddenProductIndex},
			productIndex	= productOrder.get(productId) ?? -1,
			newProductIndex	= originalProductOrder.get(productId),
			productsLocal	= [...products],
			originalProductsLocal	= [...originalProducts],
			element	= {}
		if( hiddenLocal.indexOf(productId) !== -1 ){
			let hiddenIndexLocal	= hiddenLocal.indexOf(productId)
			hiddenLocal.splice(hiddenIndexLocal, 1)
			element	= hiddenProductsLocal.splice(hiddenIndexLocal, 1)[0]
			setHidden(hiddenLocal)
			setHiddenProducts(hiddenProductsLocal)
			let originalIndex = hiddenProductIndex[productId];
			let lowerIndexCount = Object.values(hiddenProductIndex).filter(index => index < originalIndex).length,
				newLowerIndexCount = Object.values(pinnedProductIndex).filter(index => index < newProductIndex).length
			newProductIndex = newProductIndex - lowerIndexCount - newLowerIndexCount;
			originalProductsLocal.splice(newProductIndex, 0, element)
			delete hiddenProductIndexLocal[productId]
			setHiddenProductIndex(hiddenProductIndexLocal)
			setOriginalProducts(originalProductsLocal)
		}
		if( promotedLocal.indexOf(productId) === -1 && promotedLocal.length >= newProductIndex ){
			newProductIndex	= promotedLocal.length
		}
		if( buriedLocal.indexOf(productId) === -1 && ( productCount - buriedLocal.length - hiddenLocal.length ) <= newProductIndex ){
			newProductIndex	= newProductIndex - (productCount - buriedLocal.length)
		}
		productsLocal.splice(newProductIndex, 0, element)
		let king = 1;
		for (let i = promotedLocal.length - 1; i >= 0; i--) {
			pinnedItemsLocal[promotedLocal[i]] = king
			king++
		}		
		if( pinnedItemsLocal[productId] ){
			delete pinnedItemsLocal[productId]
			delete pinnedProductIndexLocal[productId]
			setPinnedProductIndex(pinnedProductIndexLocal)
		}
		if( buriedLocal.length > 0 ){
			for( let i = 0; i < buriedLocal.length; i++ ){
				let currentBurriedProductId	= buriedLocal[i]
				if( typeof pinnedItemsLocal[currentBurriedProductId] !== "undefined" && pinnedItemsLocal[currentBurriedProductId] > newProductIndex ){
					pinnedItemsLocal[currentBurriedProductId]	= pinnedItemsLocal[currentBurriedProductId] + 1
				}
			}
		}
		let positionIdsNew	= {...pinnedItemsLocal, ...selectedPromoTilesLocal},
			pinnedProductIds = Object.entries(positionIdsNew).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key);
		if (pinnedProductIds.length > 0) {
			// const idIndexMapLocal = new Map();
			// productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
			// for (let i = 0; i < pinnedProductIds.length; i++) {
			// 	let currentProductId = pinnedProductIds[i],
			// 		pinnedIndex = Number(positionIdsNew[currentProductId]),
			// 		productIndex = idIndexMapLocal.get(currentProductId);
			// 	if (typeof productIndex === "undefined" || productIndex === pinnedIndex) continue;
			// 	let element = productsLocal.splice(productIndex, 1)[0];
			// 	productsLocal.splice(pinnedIndex, 0, element);
			// 	if (productIndex < pinnedIndex) {
			// 		for (let j = productIndex; j < pinnedIndex - 1; j++) {
			// 			if (productsLocal[j]) {
			// 				let id = productsLocal[j].id;
			// 				idIndexMapLocal.set(id, j);
			// 			}
			// 		}
			// 	} else {
			// 		for (let j = pinnedIndex; j <= productIndex; j++) {
			// 			if (productsLocal[j]) {
			// 				let id = productsLocal[j].id;
			// 				idIndexMapLocal.set(id, j);
			// 			}
			// 		}
			// 	}
			// 	idIndexMapLocal.set(currentProductId, pinnedIndex - 1);
			// }
			const idIndexMapLocal = new Map();
			let elements = []
			productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let currentProductId = pinnedProductIds[i]
				let productIndex = idIndexMapLocal.get(currentProductId)
				let element = productsLocal.splice(productIndex, 1)[0]
				productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
				elements.push(element)
			}
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let element = elements[i]
				let currentProductId = pinnedProductIds[i]
				productsLocal.splice(positionIdsNew[currentProductId], 0, element)
			}
		}
		setSelectedPromoTiles(selectedPromoTilesLocal)
		setPinnedItems(pinnedItemsLocal)
		setProducts(productsLocal)
	}

	return (
		<React.Fragment>
			<MenuHeader title={"Hidden"} />
			<div className='sideBarMenuGridContainer' ref={divRef} style={{ height: height, position: "relative" }}>
				<div className='menuContentWrapper'>
					<div style={{ width: "100%", height: "100%", position: "relative" }}>
						{hiddenProducts.length === 0 ?
							<div className="emptyListMessageContainer">
								<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
									<g id="surface1">
										<path style={{ stroke: "none", fillRule: "nonzero", fill: "rgb(0%,0%,0%)", fillOpacity: 1 }} d="M 17.679688 2.011719 C 15.550781 0.289062 12.757812 -0.378906 10.078125 0.199219 C 6.585938 0.953125 3.875 3.707031 3.175781 7.207031 C 2.53125 10.34375 3.609375 13.582031 6.003906 15.707031 L 6.003906 15.75 C 6.007812 16.925781 6.5625 18.03125 7.503906 18.734375 L 7.503906 20.25 C 7.503906 21.492188 8.511719 22.5 9.753906 22.5 L 10.285156 22.5 C 10.410156 23.355469 11.140625 23.992188 12.003906 24 C 12.867188 23.992188 13.597656 23.355469 13.722656 22.5 L 14.253906 22.5 C 15.496094 22.5 16.503906 21.492188 16.503906 20.25 L 16.503906 18.734375 C 17.445312 18.03125 18.003906 16.925781 18.003906 15.75 L 18.003906 15.707031 C 19.917969 14 21.007812 11.558594 21.003906 9 C 21.011719 6.285156 19.789062 3.71875 17.679688 2.011719 Z M 15.003906 19.5 L 15.003906 20.25 C 15.003906 20.664062 14.667969 21 14.253906 21 L 9.753906 21 C 9.339844 21 9.003906 20.664062 9.003906 20.25 L 9.003906 19.5 Z M 16.777344 14.785156 C 16.605469 14.925781 16.503906 15.140625 16.503906 15.363281 L 16.503906 15.75 C 16.503906 16.992188 15.496094 18 14.253906 18 L 9.753906 18 C 8.511719 18 7.503906 16.992188 7.503906 15.75 L 7.503906 15.363281 C 7.503906 15.140625 7.402344 14.925781 7.230469 14.785156 C 5.085938 13.023438 4.09375 10.21875 4.652344 7.496094 C 5.234375 4.585938 7.484375 2.300781 10.386719 1.671875 C 10.910156 1.558594 11.449219 1.5 11.988281 1.496094 C 13.714844 1.492188 15.390625 2.085938 16.734375 3.171875 C 18.492188 4.59375 19.511719 6.738281 19.503906 9 C 19.507812 11.238281 18.507812 13.359375 16.777344 14.785156 Z M 12.753906 5.246094 C 12.753906 5.660156 12.417969 5.996094 12.003906 5.996094 C 10.347656 5.996094 9.003906 7.339844 9.003906 9 C 9.003906 9.414062 8.667969 9.75 8.253906 9.75 C 7.839844 9.75 7.503906 9.414062 7.503906 9 C 7.503906 6.511719 9.519531 4.496094 12.003906 4.496094 C 12.417969 4.496094 12.753906 4.832031 12.753906 5.246094 Z M 12.753906 5.246094 " />
									</g>
								</svg>
								<div>Hey There!</div>
								<div>The list is empty for now, but you can quickly add products by clicking the 'Hidden' icon on any product.</div>
								<div>Happy merchandising!</div>
							</div>
							:
							<div className='gridProductWrapper'>
								<div className='gridMenuProduct'>
									{hiddenProducts.map((product, prodIndex) => {
										return (
											<DraggableItem key={prodIndex} id={product}>
												<div product-id={"hidden_" + product.id} key={prodIndex} className='mainProductContainer' style={{ display: "flex", position: "relative", width: "100%", height: "100%" }}>
													<div id={product.id} className='selectableSideMenuProductCard' style={{ width: "100%", height: "100%" }}>
														<div className='productCard' onMouseOver={() => productMouseOver(product.id)}>
															<div className='imageAndActionContainer'>
																<div className='imageWrapper'>
																	<img src={product.image ? product.image : "https://storage.googleapis.com/roundclicksview/No%20Product%20Image%20Available.png"} alt={product.title} title={product.title} />
																</div>
																{(hoverProductId === product.id && !actionLoader) &&
																	<div className="actionBarContainer">
																		<div className="actionBarContent">
																			<div className="actionItemContainer">
																				<div className="actionIconWrapper" style={{ transform: "scale(0.8)" }} onClick={() => promptProduct(product.id)}>
																					<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
																						<g id="surface1">
																							<path style={{ stroke: "none", fillRule: "nonzero", fill: "currentcolor", fillOpacity: 1 }} d="M 10.394531 10.601562 C 10.199219 10.40625 10.203125 10.089844 10.398438 9.894531 L 15.648438 4.644531 C 15.84375 4.453125 16.15625 4.453125 16.351562 4.644531 L 21.601562 9.894531 C 21.796875 10.089844 21.796875 10.40625 21.601562 10.601562 C 21.410156 10.796875 21.09375 10.796875 20.898438 10.601562 L 16.5 6.207031 L 16.5 19 C 16.5 19.277344 16.277344 19.5 16 19.5 C 15.722656 19.5 15.5 19.277344 15.5 19 L 15.5 6.207031 L 11.101562 10.601562 C 10.910156 10.796875 10.589844 10.796875 10.394531 10.601562 Z M 27 18.5 C 26.722656 18.5 26.5 18.722656 26.5 19 L 26.5 26 C 26.5 26.277344 26.277344 26.5 26 26.5 L 6 26.5 C 5.722656 26.5 5.5 26.277344 5.5 26 L 5.5 19 C 5.5 18.722656 5.277344 18.5 5 18.5 C 4.722656 18.5 4.5 18.722656 4.5 19 L 4.5 26 C 4.5 26.828125 5.171875 27.5 6 27.5 L 26 27.5 C 26.828125 27.5 27.5 26.828125 27.5 26 L 27.5 19 C 27.5 18.722656 27.277344 18.5 27 18.5 Z M 27 18.5 " />
																						</g>
																					</svg>
																				</div>
																			</div>
																			<div className="actionItemContainer">
																				<div className="actionIconWrapper" style={{ transform: "scale(0.8)" }} onClick={() => buriedProduct(product.id)}>
																					<svg width="35" height="35" xmlns="http://www.w3.org/2000/svg">
																						<g>
																							<path d="M33.8029 5.71891L28.7806 0.697266C28.3177 0.232422 27.7068 0 27.1025 0C26.4964 0 25.8819 0.232422 25.4257 0.697266L23.4833 2.63102C22.3624 3.75992 21.7481 5.26203 21.7481 6.81461C21.7481 8.44953 22.3956 9.5957 22.8106 10.1847L14.3524 18.6469L10.6004 14.8856C10.1887 14.4699 9.63751 14.2574 9.09961 14.2574C8.55169 14.2574 8.01254 14.4659 7.59749 14.881L3.08782 19.3309C-0.232516 22.6512 0.0829161 31.3504 1.58503 32.8578C2.24113 33.5684 4.26853 34 6.618 34C9.6561 34 13.2328 33.2875 15.1114 31.4115L19.6191 26.9032C20.4492 26.0731 20.4492 24.7284 19.6191 23.8983L15.8532 20.1477L24.3134 11.6875C24.9028 12.1025 26.0566 12.75 27.6835 12.75C29.2361 12.75 30.7382 12.1357 31.8671 11.0155L33.8016 9.07309C34.7326 8.15469 34.7326 6.64062 33.8029 5.71891ZM13.6086 29.9094C11.1761 32.3498 4.68357 32.0842 3.10973 31.3869C2.39586 29.918 2.20461 23.2854 4.59591 20.8947L9.09961 16.3891L18.1176 25.4004L13.6086 29.9094ZM32.3021 7.57031L30.363 9.50937C26.8601 13.0123 21.4579 7.65863 24.9841 4.13047L26.9265 2.19672C27.0178 2.09711 27.1755 2.09711 27.2751 2.19672L32.2975 7.21902C32.4017 7.31797 32.4017 7.47734 32.3021 7.57031Z" fill="currentcolor"></path>
																						</g>
																						<defs>
																							<clipPath id="burryClip">
																								<rect width="34" height="34" fill="white" transform="translate(0.5)"></rect>
																							</clipPath>
																						</defs>
																					</svg>
																				</div>
																			</div>
																			{/* <div className="actionItemContainer">
																				<div className="actionIconWrapper" onClick={(e) => {e.stopPropagation();restoreProduct(product.id)}}>
																					<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor">
																						<path d="M440-122q-121-15-200.5-105.5T160-440q0-66 26-126.5T260-672l57 57q-38 34-57.5 79T240-440q0 88 56 155.5T440-202v80Zm80 0v-80q87-16 143.5-83T720-440q0-100-70-170t-170-70h-3l44 44-56 56-140-140 140-140 56 56-44 44h3q134 0 227 93t93 227q0 121-79.5 211.5T520-122Z"/>
																					</svg>
																				</div>
																			</div> */}
																			{/* <div className="actionItemContainer">
																			<div className="actionIconWrapper" style={{transform: "rotate(35deg)"}}>
																				<span className="material-symbols-outlined _materialIcon_1wjdg_97">push_pin</span>
																			</div>
																		</div> */}
																		</div>
																	</div>
																}
															</div>
															<div className='productInfoContainer'>
																<div className='productTitleWrapper'>
																	{product.title}
																</div>
																<div className='productSkuWrapper'>{product.sku}</div>
																<div className='productCardFooter'>
																	<div className='productPriceContainer'>
																		{formatPrice(product)}
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</DraggableItem>
										)
									})}
								</div>
							</div>
						}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default HiddenProducts;